const config = {
  apiBaseUrl:
    process.env.NODE_ENV === 'development'
      ? 'https://development-dot-topibro-tech.uc.r.appspot.com/api/v1'
      : 'https://api.topibrotech.com/api/v1',
};

export default config;
